import styled from 'styled-components';
import { media, layout } from '@prisjakt/ui-base';
import { itemFlex } from '../../../constants';

export const Columns = styled.div`
  display: flex;
  flex-direction: column;
  flex: ${itemFlex};

  ${media.largeUp`
    margin-right: ${layout.measurements.spacing050};
  `};
`;

export const Headers = styled.div`
  flex: ${itemFlex};
  display: flex;
`;
